import { message, Modal } from "antd";
import React, { useEffect, useState } from "react";
import Counter, { ECodeStatus } from "@Components/counter";
import { useSetState } from "ahooks";
import styled from "styled-components";
import Agreement from "@Components/agreement";
import { ESenceType } from "@Types/constants";
import { login, verificationCode_v3 } from "../../services/user";
import { loginAtom } from "@Lib/jotai/login";
import { useAtom } from "jotai";
import { Button } from "@t8891/pc";

interface IProps {
  visible: boolean;
  title: string;
  desc?: string;
  setVisible: (status: boolean) => void;
  onSuccess?: (successInfo?: any) => void;
  onClose?: (closeInfo?: any) => void;
}

const StyledInput = styled.input`
  color: #333;
  font-size: 16px;

  &::placeholder {
    color: #bbbbbb;
  }
`;

const StyledModal = styled(Modal)`
  .ant-modal-content {
    border-radius: 8px !important;
  }
  .ant-modal-close-x {
    width: 38px;
    height: 38px;
    line-height: 38px;
  }
`;

const NewLoginModel: React.FC<IProps> = (props: IProps) => {
  const { visible, title, desc, setVisible, onSuccess, onClose } = props;
  const [loginInfo, updateLoginInfo] = useAtom(loginAtom);
  const [codeStatus, setCodeStatus] = useState<ECodeStatus>(ECodeStatus.INIT);
  const [modelOpen, setModelOpen] = useState(false);
  const [state, setState] = useSetState({
    agree: localStorage.getItem("agree") == "1" ? 1 : 0,
    usernameTip: "",
    mobile: "",
    codeTip: "",
    code: "",
  });
  const { usernameTip, mobile, codeTip, code, agree } = state;

  let isLoginBtn = agree == 1 && !usernameTip && !codeTip;

  const onUsername = (event) => {
    let msg = "",
      val = event.target.value;

    if (val == "") {
      msg = "請輸入行動電話號碼";
      setCodeStatus(ECodeStatus.DISABLED);
    } else if (!/^09\d{8}$/.test(val)) {
      msg = "請輸入正確行動電話號碼！";
      setCodeStatus(ECodeStatus.DISABLED);
    } else {
      msg = "";
      setCodeStatus(ECodeStatus.INIT);
    }

    setState({
      usernameTip: msg,
      mobile: val,
    });
  };

  /** 点击驗證碼 */
  const handleSendCode = (status: ECodeStatus) => {
    if (mobile.length !== 10) return;
    setCodeStatus(status);
    if (status === ECodeStatus.PENDING) {
      handlePostCode();
    }
  };

  /** 發送驗證碼 */
  const handlePostCode = async () => {
    setCodeStatus(ECodeStatus.LOADING);
    if (!mobile) {
      message.warning("請輸入行動電話");
      return;
    }
    // 發送驗證碼請求
    const res = await verificationCode_v3({
      type: ESenceType.QUICK,
      account: mobile,
    });
    if (res.status === 12000 && res.data?.content) {
      message.success(res.data?.content);
    } else {
      message.warning(res.data);
    }
  };

  // 输入验证码
  const onCode = (event) => {
    let msg = "",
      code = event.target.value;

    if (code === "") {
      msg = "驗證碼不能為空！";
    } else if (code.length != 6) {
      msg = "驗證碼長度不正確";
    } else {
      msg = "";
    }

    setState({
      codeTip: msg,
      code: code,
    });
  };

  // 确认登陆
  const loginHandle = async (isLogin) => {
    if (!isLogin) {
      return false;
    }

    const res = (await login({
      mobile,
      code,
      agree,
      from: "pc",
    })) as any;
    if (String(res.status) == "12000") {
      onSuccess?.(res.data);
      setVisible(false);
      updateLoginInfo();
    } else {
      message.error(res.message);
    }
    return true;
  };

  useEffect(() => {
    if (!visible) {
      setModelOpen(false);
      return;
    }
    // 未註冊登錄/未登錄評論填寫完內容點擊發送彈出登入框
    if (!loginInfo) {
      setModelOpen(visible);
    } else {
      setVisible(false);
    }
  }, [loginInfo, visible]);

  return (
    <StyledModal
      centered
      maskClosable={false}
      open={modelOpen}
      onCancel={() => {
        onClose?.();
        setVisible(false);
      }}
      footer={null}
      className=''
      width={395}
    >
      <div className='flex flex-1 flex-col justify-center items-center p-16'>
        {!!title && <h3 className='text-20 font-[600] text-[#333333] leading-28 mb-10'>{title}</h3>}
        {!!desc && <p className='text-14 font-[400] text-[#999999] leading-20 mb-10'>{desc}</p>}
        <div className='flex h-46 items-center justify-start w-[314px] border-0 border-b-1 border-[#E8E8E8] border-solid px-6'>
          <p className='w-78 h-22 font-[600] text-[#333333] pr-8 mb-0 text-16' style={{ textAlignLast: "justify" }}>
            手機號:
          </p>
          <StyledInput onChange={(event) => onUsername(event)} placeholder='請輸入手機號' maxLength={10} type='tel' />
        </div>
        <div className='flex h-46 items-center justify-start w-[314px] border-0 border-b-1 border-[#E8E8E8] border-solid px-6 relative'>
          <p className='w-78 h-22 font-[600] text-[#333333] pr-8 mb-0 text-16' style={{ textAlignLast: "justify" }}>
            驗證碼:
          </p>
          <StyledInput onChange={(event) => onCode(event)} placeholder='請輸入驗證碼' maxLength={6} type='tel' />
          <Counter
            mobile={mobile}
            status={codeStatus}
            customeClassNames={`${
              mobile.length === 10 && [ECodeStatus.SUCCESS, ECodeStatus.INIT].includes(codeStatus)
                ? "text-[#fff] bg-[#3264FF]"
                : "text-[#BBB] bg-[#E8E8E8]"
            } grid w-100 h-30  rounded-16 text-16  absolute flex items-center justify-center right-0 cursor-pointer`}
            onClick={handleSendCode}
          />
        </div>

        <Button
          className={"rounded-24 mt-20 w-[314px]"}
          type='primary'
          disabled={!isLoginBtn}
          onClick={() => loginHandle(isLoginBtn)}
          style={{
            "--width": "314px",
            "--height": "48px",
          }}
        >
          確認
        </Button>
        <Agreement
          className={"w-full text-12 font-[400] text-left text-[#999] mt-20"}
          onChange={(value) => {
            setState({ agree: Number(value) });
          }}
        />
      </div>
    </StyledModal>
  );
};

export default NewLoginModel;
